<template>
  <div class="recipe-view">
    <recipe-categories :recipe="recipe" />
    <div class="content container">
      <div class="intro" v-if="recipe.Description">
        <div>
          <h5>Intro</h5>
          <p v-html="recipe.Description"></p>
        </div>
      </div>
      <similar-recipes />
      <div class="ingredients">
        <h5>Ingredients</h5>
        <ingredients :ingredients="recipe.IngredientsList" />
      </div>
      <div class="instructions">
        <h5>Instructions</h5>
        <div class="instructions-body">
          <!-- <div> rather than <p> so the step can legally contain <ul>/<ol>
               nested bullet lists - <p> auto-closes before a block element. -->
          <div
            v-for="(instruction, i) in instructionList"
            :key="i"
            class="step"
            :class="{ completed: instructionDone[i] }"
            @click="toggleInstructionDone(i)"
            v-html="instruction"
          ></div>
        </div>
        <div v-if="notesHtml" class="recipe-notes">
          <h5>Notes</h5>
          <div class="recipe-notes-box" v-html="notesHtml"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import RecipeCategories from "@/components/pages/recipe/RecipeCategories";
import SimilarRecipes from "@/components/pages/recipe/SimilarRecipes";
import ingredients from "@/components/pages/recipe/Ingredients";
import { mapGetters } from "vuex";
import { db } from "@/firebase.js";
import recipeHelper from '@/helpers/recipeHelper'

export default {
  data() {
    return {
      recipe: {},
      initialIngredients: [],
      instructionList: [],
      // One boolean per instruction step; click toggles. Mirrors the same
      // tap-to-check pattern as ingredients.
      instructionDone: []
    };
  },
  methods: {
    toggleInstructionDone(index) {
      this.$set(this.instructionDone, index, !this.instructionDone[index]);
    },
    async setFavorite() {
      await db
        .collection("FavoriteRecipes")
        .doc(this.recipe.Id.toString())
        .set({});
      this.$store.dispatch("getFavorites");
    },
    async deleteFavorite() {
      await db
        .collection("FavoriteRecipes")
        .doc(this.recipe.Id.toString())
        .delete();
      this.$store.dispatch("getFavorites");
    }
  },
  created() {
    this.recipe = this.getRecipeById(this.$route.params.url);
    this.instructionList = recipeHelper.removeHtml(this.recipe.RecipeInstructions)
    this.instructionDone = this.instructionList.map(() => false);
    this.$store.commit("setRecipeUrl", this.recipe.id);
    this.$store.commit("setTitle", this.recipe.Title);
    this.initialIngredients = this.recipe.IngredientsList;
  },
  computed: {
    ...mapGetters([
      "getRecipeById",
      "getRecipeDoneById",
      "getRecipeFavoriteById"
    ]),
    isDone() {
      return this.getRecipeDoneById(this.recipe.Id);
    },
    isFavorite() {
      return this.getRecipeFavoriteById(this.recipe.Id);
    },
    notesHtml() {
      if (!this.recipe) return '';
      // Backward-compat: legacy recipes stored Notes as a string[] (one per
      // card). Join those with paragraph breaks so they render in the new
      // single-card layout without losing data.
      if (Array.isArray(this.recipe.Notes)) {
        return this.recipe.Notes.filter(Boolean).join('<br /><br />');
      }
      return this.recipe.Notes || '';
    }
  },
  components: {
    "recipe-categories": RecipeCategories,
    "similar-recipes": SimilarRecipes,
    ingredients
  }
};
</script>

<style lang="scss">
</style>